var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Model, validator } from "@musicaudienceexchange/toccata";
export class EventIndexDocument extends Model {
}
EventIndexDocument.defaults = {
    deletedAt: 0,
    endedAt: 0,
    playlistSongsCount: 0,
};
__decorate([
    validator.IsString()
], EventIndexDocument.prototype, "venue", void 0);
__decorate([
    validator.IsString()
], EventIndexDocument.prototype, "artistName", void 0);
__decorate([
    validator.IsArray(),
    validator.IsOptional()
], EventIndexDocument.prototype, "coordinates", void 0);
__decorate([
    validator.IsString()
], EventIndexDocument.prototype, "type", void 0);
__decorate([
    validator.IsString(),
    validator.IsOptional()
], EventIndexDocument.prototype, "image", void 0);
__decorate([
    validator.IsNumber()
], EventIndexDocument.prototype, "startsAt", void 0);
__decorate([
    validator.IsNumber()
], EventIndexDocument.prototype, "endedAt", void 0);
__decorate([
    validator.IsNumber()
], EventIndexDocument.prototype, "deletedAt", void 0);
__decorate([
    validator.IsString()
], EventIndexDocument.prototype, "status", void 0);
__decorate([
    validator.IsString(),
    validator.IsOptional()
], EventIndexDocument.prototype, "address", void 0);
__decorate([
    validator.IsString(),
    validator.IsOptional()
], EventIndexDocument.prototype, "brandingId", void 0);
__decorate([
    validator.IsString()
], EventIndexDocument.prototype, "groupId", void 0);
__decorate([
    validator.IsNumber(),
    validator.IsOptional()
], EventIndexDocument.prototype, "playlistSongsCount", void 0);
//# sourceMappingURL=index.js.map